/* shah */
import React from 'react'

const HighlightFocusIcon = () => {
    return (
        <svg id="SmallBoxSVG-focusOrientation" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2460 5100 c-94 -49 -120 -112 -120 -285 0 -132 -1 -135 -55 -135
-13 0 -80 -11 -150 -25 -463 -92 -905 -354 -1207 -714 -251 -301 -426 -679
-478 -1036 -20 -140 -2 -125 -144 -125 -138 0 -192 -13 -239 -58 -46 -44 -67
-94 -67 -162 0 -73 23 -125 75 -168 52 -42 96 -52 233 -52 139 0 122 15 142
-125 52 -355 228 -738 478 -1036 303 -361 739 -619 1205 -713 71 -14 139 -26
152 -26 54 0 55 -3 55 -135 0 -137 13 -191 58 -238 44 -46 94 -67 162 -67 73
0 125 23 168 75 42 52 52 96 52 233 0 129 1 132 57 132 14 0 81 11 149 25 466
94 903 353 1206 714 250 299 426 680 478 1036 20 140 3 125 142 125 137 0 181
10 233 52 99 82 103 240 8 330 -47 45 -101 58 -239 58 -142 0 -124 -15 -144
125 -52 357 -227 735 -478 1035 -320 383 -809 660 -1287 730 -140 20 -125 2
-125 144 0 175 -27 238 -122 287 -50 25 -150 25 -198 -1z m525 -896 c642 -163
1152 -722 1253 -1375 l9 -57 -37 -6 c-52 -8 -114 -56 -139 -108 -59 -124 14
-284 139 -304 l37 -6 -9 -57 c-66 -441 -339 -870 -718 -1130 -209 -143 -460
-244 -691 -279 l-57 -9 -6 37 c-8 52 -56 114 -108 139 -124 59 -284 -14 -304
-139 l-6 -37 -57 9 c-441 66 -870 339 -1130 718 -143 209 -244 460 -279 691
l-9 57 37 6 c125 20 198 180 139 304 -25 52 -87 100 -139 108 l-37 6 9 57 c80
530 447 1022 942 1261 157 76 399 149 492 150 28 0 32 -4 38 -34 10 -51 58
-110 111 -136 60 -29 154 -24 210 10 44 27 84 84 91 131 l6 36 57 -9 c31 -5
101 -20 156 -34z"/>
                <path d="M2374 3616 c-232 -44 -406 -136 -570 -300 -142 -141 -230 -294 -282
-485 -23 -86 -26 -114 -26 -271 0 -157 3 -185 26 -271 101 -375 392 -666 764
-766 89 -24 116 -27 274 -27 158 0 185 3 274 27 372 100 663 392 764 766 23
86 26 114 26 271 0 157 -3 185 -26 271 -52 191 -140 344 -282 485 -142 143
-296 232 -485 281 -119 31 -344 40 -457 19z"/>
            </g>
        </svg>

    )
}

export default HighlightFocusIcon